import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import get from 'lodash/get';

import { Box, Typography, useTheme } from '@sbv-clients/ui-shared';

import { usePendingOpenshiftApprovalsGet } from '../../../services/dashboard';
import CallOffsReport from './calloffs-report';
import Counter from './counter';
import PendingAbsenceCounter from './pending-absence-counter';

interface ShiftsStatusProps {
  departmentId: number;
  positionId: number;
  startDate: Date;
  endDate: Date;
}

const ShiftsStatus = ({
  departmentId,
  positionId,
  startDate,
  endDate,
}: ShiftsStatusProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const pendingOpenshiftApprovalsResponse = usePendingOpenshiftApprovalsGet(
    departmentId,
    positionId
  );
  const pendingOpenshiftApprovalsCount = get(
    pendingOpenshiftApprovalsResponse,
    'data.openshiftsApprovals',
    0
  );
  const goToOpenshiftsPage = useCallback(() => {
    navigate('/openshifts');
  }, [navigate]);
  return (
    <Box>
      <Typography
        variant="subtitle2"
        color={theme.text.sectionSubtitle}
        sx={{ my: 3 }}
      >
        Shifts Status
      </Typography>
      <Box
        display="grid"
        gap={4}
        gridTemplateColumns={{
          xs: '1fr 1fr',
          md: '250px 250px 250px',
          lg: '250px',
        }}
      >
        <Counter
          title="Pending Shift Approvals"
          counterValue={pendingOpenshiftApprovalsCount}
          backgroundColor={theme.colors.primary.light}
          onClick={goToOpenshiftsPage}
        />
        <CallOffsReport
          departmentId={departmentId}
          positionId={positionId}
          startDate={startDate}
          endDate={endDate}
        />
        <PendingAbsenceCounter
          departmentId={departmentId}
          positionId={positionId}
        />
      </Box>
    </Box>
  );
};

export default ShiftsStatus;
